import React from 'react'
import PropTypes from 'prop-types'

import ShowOnVisible from 'Components/ShowOnVisible'
import Demographics from 'Components/Demographics/DemographicsApiContainer'
import Collapsible from 'Components/Collapsible'

const ListingDemographics = ({
  googleAnalyticsEvent,
  listing,
  makeItVisible,
  openCollapseTargetId,
  collapseInputId,
  handleDemographicMapClick,
  collapsibleIdSuffix,
  places,
}) => {
  const { title, name } = listing || {}
  const lowestArea = listing && listing.lowest_area

  const areaName = lowestArea ? lowestArea.display_name : ''
  return (
    <Collapsible
      inputId={collapseInputId || `Demographics-${collapsibleIdSuffix}`}
      title={`Explore ${areaName}`}
      seoText={
        `Learn about the area and demographics around ${title || name || ''}`
      }
      gaActionTitle="Demographics"
      openCollapseTargetId={openCollapseTargetId}
    >
      <ShowOnVisible makeItVisible={makeItVisible}>
        <Demographics
          listing={listing}
          googleAnalyticsEvent={googleAnalyticsEvent}
          handleDemographicMapClick={handleDemographicMapClick}
          source={'listing'}
          key={`Demographics-${collapsibleIdSuffix}`}
          places={places}
        />
      </ShowOnVisible>
    </Collapsible>
  )
}


ListingDemographics.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    lowest_area: PropTypes.shape({}),
  }),
  makeItVisible: PropTypes.bool,
  openCollapseTargetId: PropTypes.string,
  collapseInputId: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
  handleDemographicMapClick: PropTypes.func,
  collapsibleIdSuffix: PropTypes.string,
  places: PropTypes.shape({}),
}

export default ListingDemographics
